import moment from 'moment'
import 'moment/locale/zh-cn'
import { numberMul } from './calculate'

const digitsRE = /(\d{3})(?=\d)/g

function currency(value, decimals, symbol) {
  value = parseFloat(value)
  if (!isFinite(value) || (!value && value !== 0)) return ''
  symbol = symbol != null ? symbol : '￥'
  decimals = decimals != null ? decimals : 2
  let stringified = Math.abs(value).toFixed(decimals)
  let _int = decimals ? stringified.slice(0, -1 - decimals) : stringified
  let i = _int.length % 3
  let head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : ''
  let _float = decimals ? stringified.slice(-1 - decimals) : ''
  let sign = value < 0 ? '-' : ''
  return sign + symbol + head + _int.slice(i).replace(digitsRE, '$1,') + _float
}

function numberF(value, decimals) {
  value = parseFloat(value)
  if (!isFinite(value) || (!value && value !== 0)) return ''
  decimals = decimals != null ? decimals : 2
  let stringified = Math.abs(value).toFixed(decimals)
  let _int = decimals ? stringified.slice(0, -1 - decimals) : stringified
  let i = _int.length % 3
  let head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : ''
  let _float = decimals ? stringified.slice(-1 - decimals) : ''
  let sign = value < 0 ? '-' : ''
  return sign + head + _int.slice(i).replace(digitsRE, '$1,') + _float
}

function percent(value, decimals, symbol) {
  value = numberMul(value, 100)
  value = parseFloat(value)
  if (!isFinite(value) || (!value && value !== 0)) return ''
  symbol = symbol != null ? symbol : '%'
  decimals = decimals != null ? decimals : 2
  let stringified = Math.abs(value).toFixed(decimals)
  let _int = decimals ? stringified.slice(0, -1 - decimals) : stringified
  let i = _int.length % 3
  let head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : ''
  let _float = decimals ? stringified.slice(-1 - decimals) : ''
  let sign = value < 0 ? '-' : ''
  return sign + head + _int.slice(i).replace(digitsRE, '$1,') + _float + symbol
}

function progress(value, decimals, symbol) {
  value = numberMul(value, 100)
  value = parseFloat(value)
  if (!isFinite(value) || (!value && value !== 0)) return ''
  symbol = symbol != null ? symbol : '%'
  decimals = decimals != null ? decimals : 2
  let reg = new RegExp(`\\d+\\.?\\d{0,${decimals}}`)
  let stringified = Math.abs(value).toString()
  stringified = stringified.match(reg)[0] - 0
  stringified = stringified.toFixed(decimals)
  let _int = decimals ? stringified.slice(0, -1 - decimals) : stringified
  let i = _int.length % 3
  let head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : ''
  let _float = decimals ? stringified.slice(-1 - decimals) : ''
  let sign = value < 0 ? '-' : ''
  return sign + head + _int.slice(i).replace(digitsRE, '$1,') + _float + symbol
}

// 日期格式自定义
export function transformDate(date) {
  // 满足 年 / - 三种模式的 日期格式
  var REG = /(2[0-9]{3})[年 | \/ | -]([0-9]{1,2})[月 | \/ | -]([0-9]{1,2})/g
  var reg = new RegExp(REG)
  reg.exec(date)
  var { $1, $2, $3 } = RegExp
  $2 = Number($2) < 10 ? '0' + Number($2) : $2
  $3 = Number($3) < 10 ? '0' + Number($3) : $3
  if ($1 && $2 && $3) return `${$1}-${$2}-${$3}`
  return null
}

/**
过滤器
 * @param {String} type 过滤方式
 * @param {String,Number} format 过滤格式（如选择date时可为YYYY-MM-DD HH:mm:ss）
 * @param {String} symbol 某些过滤方式可选（如选择currency时可为金额前的单位￥、$）
*/
export function filters(value, type, format, symbol) {
  switch (type) {
    case 'currency':
      return currency(value, format, symbol)
    case 'number':
      return numberF(value, format)
    case 'date': // 日期时间的格式：YYYY-MM-DD HH:mm:ss
      if (!value) return value
      return moment(value).format(format)
    case 'percent':
      if (!value && value !== 0) return value
      return percent(value, format, symbol)
    case 'progress':
      if (!value && value !== 0) return value
      return progress(value, format, symbol)
    default:
      return value
  }
}
